import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integration-kit',
  templateUrl: './integration-kit.component.html',
  styleUrls: ['./integration-kit.component.scss']
})
export class IntegrationKitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.openUrl();
  }

  openUrl(){
    window.location.href='https://www.pay10.com/plugin.php';
  }

}
